import { PAGES_GAP, ART_BOARD_OFFSETS } from '../../configs/index.js';

var calculateCanvasHeight = function calculateCanvasHeight(_ref) {
  var zoom = _ref.zoom,
      pagesCount = _ref.pagesCount,
      scaleY = _ref.scaleY,
      artBoardHeight = _ref.artBoardHeight;
  return zoom * (pagesCount * scaleY * artBoardHeight + PAGES_GAP * (pagesCount - 1) + ART_BOARD_OFFSETS.top + ART_BOARD_OFFSETS.bottom);
};

export { calculateCanvasHeight, calculateCanvasHeight as default };
